import { QCNamingConvention } from './qc-naming-convention';

export class QCDomesticSourceMasterNamingConvention extends QCNamingConvention {

  get description(): string {
    return "Domestic Source Master";
  }

  get generatedName(): string {
    let name = this.foreignEpisode + '_' + this.domesticEpisode + '_' + this.format + '_DSM_' + this.standard + '_' + this.aspectRatio + '_' + this.programTitle;
    if (this.revision != null) {
      name += '_R' + this.revision
    }
    return name;
  }

  static get requiredComponents(): string[] {
    return [
      'aspectRatio',
      'domesticEpisode',
      'foreignEpisode',
      'format',
      'programTitle',
      'standard'
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/qc/qc-naming-conventions/qc-domestic-source-master-naming-convention.ts